import PageContainer from '@Guidelines/Layout/PageContainer';
import HomeContent from '@UI/Pages/Home/HomeContent';
import type * as React from 'react';

/**
 * Landing screen of the connected application: account-level indicators, filtered by perimeter and
 * period. Mounted outside `RequireFacility` — it works without a working agency.
 */
const HomePage: React.FC = () => {
	return (
		<PageContainer>
			<HomeContent />
		</PageContainer>
	);
};

export default HomePage;
